@if (_dropdownItems().length && _menuBlocks().length) {
  <div
    class="dropdown-container"
    [myreSpinLoader]="_backButtonIsLoading()"
    [class.arrow-hovered]="_isArrowHovered()"
    #forDropdown
  >
    @if (!_backButtonIsLoading()) {
      @if (_routingService.backButtonStatus() === 'visible') {
        <i
          class="myre-icon-arrow_back"
          role="button"
          tabindex="0"
          (click)="_routingService.navigateToParent()"
          (mouseenter)="_isArrowHovered.set(true)"
          (mouseleave)="_isArrowHovered.set(false)"
        ></i>
      }

      <myre-actions-dropdown
        ellipsis
        [dropdownItems]="_dropdownItems()"
        [buttonHeight]="ButtonHeight.Medium"
        [dropdownSlaveFrom]="forDropdown"
        dropdownWidth="sameParent"
      >
        <div
          class="primary-menu-button"
          [class]="_displayDropdownIcon() ? 'space-between' : 'start'"
        >
          <div
            ellipsis
            [class.first-block-flex]="_selectedPrimaryMenuItem()?.imgSource"
          >
            @if (_selectedPrimaryMenuItem()?.imgSource; as imgSource) {
              <img [ngSrc]="imgSource" width="24" height="24" />
            }
            <span>{{ _selectedPrimaryMenuItemLabel() }}</span>
          </div>

          @if (_displayDropdownIcon()) {
            <i class="myre-icon-arrow_dropdown"></i>
          }
        </div>
      </myre-actions-dropdown>
    }
  </div>

  <div class="items-container">
    @for (
      menuBlock of _menuBlocks();
      let first = $first;
      track _trackBy($index, menuBlock)
    ) {
      <myre-menu-items
        [class.spacing]="first"
        [type]="menuBlock.type"
        [items]="menuBlock.items"
      />
    }
  </div>
} @else {
  <myre-box-loader />
}

<myre-footer-minimalist class="footer-container" />
